import { createContext, useContext, useEffect } from 'react';

/**
 * Le dernier maillon du fil d'Ariane de la barre du haut : « Comptes › Mariam ».
 *
 * Le premier maillon vient du menu (le libellé de l'entrée qui mène ici, D19) ;
 * celui-ci, seul l'écran le connaît — le nom du compte affiché, par exemple. Il
 * le déclare par `useTrail`, et le retire en se démontant.
 */
export const TrailContext = createContext<(label: string | null) => void>(() => undefined);

export function useTrail(label: string | null): void {
    const setTrail = useContext(TrailContext);

    useEffect(() => {
        setTrail(label);

        return () => setTrail(null);
    }, [label, setTrail]);
}
